import styled, { keyframes } from 'styled-components';
import label from './img/label-green.svg';
import labelBlue from './img/label-blue.svg';

interface Props {
	chart?: boolean;
}

export const Container = styled.div`
	position: relative;
`;

export const ChartWrapper = styled.div<Props>`
	position: relative;
	height: 100%;
	min-height: 90px;
	width: 100%;
	margin-top: ${({ chart }) => (chart ? '90px' : '50px')};
`;

export const Chart = styled.div<Props>`
	position: relative;
	height: 100%;
	min-height: ${({ chart }) => (chart ? '90px' : '130px')};
	width: 0;
	overflow: hidden;
	animation: chartAnimation 1.6s linear both;
	padding: 0 20px;

	img {
		position: absolute;
		width: calc(100vw - 80px);
		top: 0;
		left: 20px;
		max-width: calc(425px - 40px);
	}

	@keyframes chartAnimation {
		0% {
			width: 0;
		}

		100% {
			width: 100%;
		}
	}
`;

export const ChartMonts = styled.div`
	position: absolute;
	width: 100%;
	bottom: 2%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 20px;

	p {
		font-size: 10px;
		line-height: 12px;
		color: ${({ theme }) => theme.colors.text11};
		opacity: 0.5;
		text-transform: uppercase;
	}

	@media (min-width: 428px) {
		bottom: -5%;
	}
`;

export const Description1 = styled.div<Props>`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	position: absolute;
	top: ${({ chart }) => (chart ? '-65%' : '0')};
	left: ${({ chart }) => (chart ? '50%' : '65%')};
	transform: translate(-50%, 0);

	p {
		font-size: 10px;
		line-height: 12px;
		text-transform: uppercase;
		color: ${({ theme }) => theme.colors.text22};
		margin-bottom: 1px;
	}
`;

export const Label = styled.div<Props>`
	position: absolute;
	background-image: url(${label});
	display: flex;
	align-items: center;
	justify-content: center;
	width: 51px;
	height: 24px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
	padding-bottom: 4px;
	font-weight: 700;
	font-size: 12px;
	line-height: 15px;
	text-align: center;
	letter-spacing: -0.02em;
	color: #ffffff;
	position: absolute;
	opacity: 0;
	animation: fadeIn 0.4s 0.4s linear both;

	&:nth-child(1) {
		top: ${({ chart }) => (chart ? '-32%' : '-26%')};
		left: 0.5%;
		background-image: ${({ chart }) => (chart ? `url(${label})` : `url(${labelBlue})`)};
	}

	&:nth-child(2) {
		top: ${({ chart }) => (chart ? '-32%' : '-4%')};
		left: 28.5%;
		background-image: ${({ chart }) => (chart ? `url(${label})` : `url(${labelBlue})`)};
	}

	&:nth-child(3) {
		top: ${({ chart }) => (chart ? '-32%' : '20%')};
		right: 28.5%;
	}

	&:nth-child(4) {
		top: ${({ chart }) => (chart ? '-32%' : '20%')};
		right: 0.5%;
	}

	@keyframes fadeIn {
		0% {
			opacity: 0;
		}

		100% {
			opacity: 1;
		}
	}
`;

export const Description2 = styled.div<Props>`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	position: absolute;
	bottom: 27px;
	left: ${({ chart }) => (chart ? '50%' : '70%')};
	transform: translate(-50%, 0);

	p {
		font-size: 10px;
		line-height: 12px;
		text-transform: uppercase;
		color: ${({ theme }) => theme.colors.text16};
		margin-bottom: 1px;
	}
`;
